import type { GetMyFeatureFlagsResult } from "api-contracts/rpc/feature-flags";
import { appContext } from "ui-common/appContext";
import { queryOptions } from "ui-common/query-options";
import { rpc } from "ui-common/services/rpc";

export const featureFlagsQueryOptions = queryOptions({
  queryKey: ["feature-flags"],
  queryFn: async (): Promise<GetMyFeatureFlagsResult> => {
    await appContext.ready;

    if (!appContext.isAuthenticated) return { features: [] };
    return rpc("get-my-feature-flags", {});
  },
});
